import * as React from 'react'

import { cn } from '~/styled'

import { Divider } from '../../divider/Divider'

type MarkdownThematicBreakProps = {
  className?: string
}

export const MarkdownThematicBreak = ({
  className
}: MarkdownThematicBreakProps) => (
  <Divider className={cn('w-full', className)} />
)
